/**
 * Ponto de entrada do painel administrativo, identico ao do `_template` da plataforma.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// A UNICA linha de CSS que um app escreve. Toda a folha do sistema vem daqui, com os tokens da
// marca Lu Barros dentro, e nenhum app tem estilo proprio.
import '@complexity/ui/styles.css';

import { App } from './App.js';

// O index.html traz o #root; se ele sumir, a falha precisa ser dita na partida, e nao virar
// uma tela branca sem erro.
const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root nao encontrado no index.html.');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
